import type { Loan } from 'app/types/loan';
import { getLoanETA, getLoanType, LoanETA, LoanType } from 'app/types/loan';
import type { User } from 'app/types/user';

export function getLoanInfos(loan?: Loan | null, user?: User) {
  const type = getLoanType(loan?.borrower, user);
  const status = loan ? getLoanETA(loan) : undefined;
  const otherUser: Loan['borrower'] | Loan['lender'] | undefined =
    loan?.borrower.id === user?.id ? loan?.lender : loan?.borrower;
  return {
    loanType: type,
    loanStatus: status,
    isLate: status === LoanETA.late,
    isLender: type === LoanType.Lending,
    otherUser,
  };
}
